import { useState } from 'react';
import './check-circle.scss';

interface Props {
  onCheck: any;
  value: boolean;
  text: string;
}

const CheckCircle = ({ onCheck, value, text }: Props): JSX.Element => {
  const onClick = () => {
    onCheck(!value);
  };

  return (
    <div className="check-circle">
      <label className="container">
        <input type="checkbox" checked={value} onChange={onClick} />
        <span className="checkmark"></span>
        <div className="check-circle__text">{text}</div>
      </label>
    </div>
  );
};

export { CheckCircle };
